import React from "react";
import { Grid, TextField } from "@material-ui/core"
import { Controller, useFormContext } from "react-hook-form"

const RHFInputField = ({ name, label, type = "text", variant = "outlined", fullWidth = true, rules = {}, placeholder = "" }) => {
    const { control } = useFormContext();

    return (
        <Grid item xs={12}>
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({ field: { ref, ...field }, fieldState: { error } }) => <TextField {...field} inputRef={ref} error={error} helperText={error && error.message} label={label} type={type} variant={variant} fullWidth={fullWidth} placeholder={placeholder} />}
            />
        </Grid>
    )
}

export default RHFInputField;